import script from "./ProfitLoss.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfitLoss.vue?vue&type=script&setup=true&lang=ts"

import "./ProfitLoss.vue?vue&type=style&index=0&id=b32474ee&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b32474ee"]])

export default __exports__